
import { onMounted, ref } from 'vue';
import   axios   from 'axios';
import {Raterange} from '@/models/raterange'
import  AdminPagination from '@/components/AdminPagination.vue'
export default {
  name:"AdminRaterangeList",
  components: {AdminPagination} ,
  setup(){
      const rateranges = ref([]);
   
      const lastPage = ref(0);


  const load = async (page=1)=>{
   const {data} = await  axios.get(`rateranges?page=${page}`);
          rateranges.value =data.data;
        lastPage.value=data.meta.last_page;   
    }

      onMounted(load);

     

const del =async (id:number)=>{
  if(confirm('Are You Sure?')){
    await axios.delete(`rateranges/${id}`);

    rateranges.value = rateranges.value.filter((u: Raterange)=> u.id !== id);

  }

}


      return {
        rateranges,
      lastPage,
        del,
        load
      }
      
    }    
}
